import { SET_SEARCH, CLEAR_SEARCH } from "../constants";
import { AccountSearchResult } from "../../types/search";

const initial_state = {
  loading: false,
  totalResults: 0,
  account: "",
  customerContact: "",
  list: [] as AccountSearchResult[]
};

interface stateOptions {
  type: string;
  payload?: any;
}

export default function AccountSearch(state = initial_state, { type, payload }: stateOptions) {
  switch (type) {
    case SET_SEARCH:
      return {
        ...state,
        totalResults: payload.totalResults,
        list: payload.results,
        account: payload.account,
        customerContact: payload.customerContact
      };

    case CLEAR_SEARCH:
      return {
        ...initial_state
      };

    default:
      return state;
  }
}
